import React from 'react';
import Table from '../../../../components/_table/Table/Table';
import { columns } from './columns';
import Button from '../../../../components/Button';
import { COUPON_UN_USAGE_HISTORY_LIST_FILTER_OPTION_MODEL } from '../../../../store/modules/coupon/models';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import './CouponDetailUnUsageHistoryList.scss';

const CouponDetailUnUsageHistoryList = (props) => {
  const { couponUnUsageHistory, getList, filterOption, pagination, getCouponUnUsageHistoryListExcelDownload } = props;

  return (
    <div className="coupon-detail-un-usage-history-content">
      <div className="excel-button-list">
        <Button isRadius color="light" text="엑셀 다운로드" onClick={getCouponUnUsageHistoryListExcelDownload} />
      </div>

      <Table
        className="coupon-detail-un-usage-history-list"
        columns={(utils) =>
          columns({
            ...utils,
            isFilter: true,
          })
        }
        rowKey={(record) => record.id}
        list={couponUnUsageHistory}
        initialOption={{
          filterOption: COUPON_UN_USAGE_HISTORY_LIST_FILTER_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        }}
        filterOption={filterOption}
        pagination={pagination}
        size="small"
        scroll={{ x: true }}
        bordered={true}
        getExcelDownload={getCouponUnUsageHistoryListExcelDownload}
        getList={(option) =>
          getList({
            ...option,
          })
        }
      />
    </div>
  );
};

export default CouponDetailUnUsageHistoryList;
